import { getImgBaseUrl } from './getImgBaseUrl';
import { ImageParams, stringifyImageParams } from './stringifyImageParams';

export const getDesignImageUrl = (designId: string, params: ImageParams) =>
  `${getImgBaseUrl()}/designs/${designId}${stringifyImageParams(params)}.png`;
